<template>
  <cs-preloader-overlay loading />
</template>

<script>
import { getQueryParamsAsObject } from 'lib/utils/url';

import HTTPService from '@/services/Http';
import logrocket from '@/services/logrocket';

import { CABINET } from '@/router/const';

export default {
  name: 'PartnerTransactionBrowsingAccess',
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      const GET_PARAMS = ['merchant_id', 'project_id'];

      // TODO: @danealton @damir вынести в метод утилит т.к. уже много где используется подобная конструкция
      const rawString = window.location.search.slice(1);
      const preparedMap = getQueryParamsAsObject(decodeURIComponent(rawString));
      const filteredParams = Object.keys(preparedMap).filter(parameter => GET_PARAMS.includes(parameter));

      const preparedParams = filteredParams.reduce((acc, curr) => {
        acc[curr] = preparedMap[curr] !== 'undefined' ? preparedMap[curr] : '';
        return acc;
      }, {});

      const payload = {
        projectId: preparedParams.project_id,
        merchantId: preparedParams.merchant_id,
      };

      try {
        await HTTPService.partnerTransactionBrowsingAccess(payload);

        this.$alert({
          type: 'success',
          text: this.$t('access.granted'),
        });
      } catch (error) {
        logrocket.logger(error);

        this.$alert({
          type: 'warning',
          text: this.$t('something.wrong'),
        });
      }

      this.$router.push({ name: CABINET });
    },
  },
};
</script>
